export default __webpack_public_path__ + "static/media/vantagem-competitiva.440a17e0.svg";